import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const CreateSupportCaseModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "CreateSupportCaseModalContainer" */
      './CreateSupportCaseModalContainer'
    ),
  loading: LoadingModal,
});
